import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=04c81382"
import script from "./Debt.vue?vue&type=script&lang=ts"
export * from "./Debt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports